import { connect } from 'react-redux';
import { selectActiveVenueId } from 'selectors/general';
import { selectSelectedInstructorIdFilter, selectSchedulesInstructors } from '../../Schedules.selectors';
import { setSchedulesBoardInstructorsFilters } from '../../Schedules.reducers';
import ScheduleBoardInstructorsFilter from './ScheduleBoardInstructorsFilter';

const mapStateToProps = state => {
  const venueId = selectActiveVenueId(state);

  return {
    instructors: selectSchedulesInstructors(state, venueId),
    selectedInstructors: selectSelectedInstructorIdFilter(state),
  };
};

const mapDispatchToProps = {
  updateSelection: instructors => setSchedulesBoardInstructorsFilters(instructors),
};

export default connect(mapStateToProps, mapDispatchToProps)(ScheduleBoardInstructorsFilter);
